import React from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {getImpl} from "../../../backend/LgSetup";
import {TildaB} from "./common/TildaB";
import {calculateLeadGenerationUrl, calcWhere} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function LgFullHeader() {
    return (
        <div>
            <Container>
                <TildaB>
                    <span className="normal">Мы собираемся организовать этот концерт в </span>
                    <strong><span><strong
                        className="normal">{calcWhere(appdata)}.</strong></span></strong>
                </TildaB>
                <TildaB>
                    <div className="fontBig center"> Приглашать ли вас на эти концерты в <strong
                        className="normal">{getImpl(appdata.geo, ["name#where"])}?</strong>
                    </div>
                </TildaB>
                <TildaB>
                    <div>
                        <a href={calculateLeadGenerationUrl(appdata)} target="_parent"
                           className="myButton myButtonYellow">Да, пригласите меня!</a>
                    </div>
                </TildaB>
            </Container>
        </div>
    );
}


